import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Home, LoginView, LoginWithTokenView } from './views';
import registerServiceWorker from './registerServiceWorker';
import './index.scss';
import { Provider } from 'react-redux';
import 'semantic-ui-less/semantic.less';
import { requiresAuthentication } from './containers/requiresAuthentication';
import { ConnectedRouter } from 'react-router-redux';
import { Route } from 'react-router';
import { store, history, initializeApp } from './utils/init';
import { IntlProvider, addLocaleData } from 'react-intl';
import * as localeEn from 'react-intl/locale-data/en';
import * as localeZh from 'react-intl/locale-data/zh';

const messagesZh = require('./translations/zh.json');
const messagesEn = require('./translations/en.json');

const messages = {
  zh: messagesZh,
  en: messagesEn,
};
const language = navigator.language.split(/[-_]/)[0];  // language without region code


addLocaleData([...localeEn, ...localeZh]);


initializeApp().then(() => {
  ReactDOM.render(
    <IntlProvider locale={language} messages={messages[language]}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <span>
            <Route exact={true} path="/home" component={requiresAuthentication(Home)} />
            <Route exact={true} path="/auth" component={LoginView} />
            <Route exact={true} path="/" component={LoginView} />
            <Route exact={true} path="/login-with-token" component={LoginWithTokenView} />
          </span>
        </ConnectedRouter>
      </Provider>
    </IntlProvider>,
    document.getElementById('root') as HTMLElement,
  );

  registerServiceWorker();
});




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx